import request from '@/utils/request'

/* 用户登录 */
export function login(data) {
  return request({
    url: '/account/doctor/signin',
    method: 'post',
    data
  })
}

/* 获取用户基本信息 */
export function getInfo() {
  return request({
    url: '/account/',
    method: 'get'
  })
}

/* 退出 */
export function logout() {
  return request({
    url: '/account/signout',
    method: 'post'
  })
}

// 获取所有的VTX用户
export function getAllUser(params) {
  return request({
    url: '/account/param/match',
    method: 'get',
    params
  })
}

// 获取某个用户的全部信息
export function getSingleUserInfo(uid) {
  return request({
    url: '/account/' + uid,
    method: 'get'
  })
}

// 检查记录
export function checkList(params) {
  return request({
    url: '/train/results',
    method: 'get',
    params
  })
}

/** 创建患者 */
export function createPatient(data) {
  return request({
    url: '/account',
    method: 'post',
    data
  })
}


